// extracted by mini-css-extract-plugin
module.exports = {"Content":"projects_Content__1mJ68","flex-direction":"projects_flex-direction__1thqz"};